import React from "react";
import axios from 'axios';
import { SuccessResponse, ErrorResponse, QueryParamsFormat, GetAuthToken } from './Http-utils';
import { useMsal } from "@azure/msal-react";
import { setAuthToken } from "../../sessions/auth_session";
import environment from "../../../environment/environment";
import AuthService from "../../auth";
import { log } from "../../../console-config.log";
// import CommonAlertDialog from "../../../utils/common-alert-dialog";

const SUBSCRIPTION_KEY = environment.business_account_service.subscriptionKey

const HttpPost = (path, payload) => {

    let isAuthenticated = AuthService.isUserLoggedIn();

    var promise = new Promise((resolve, reject) => {
 

            if (isAuthenticated) {
              AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualPost(path, payload, accessToken)

                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr: ", err)
                  
                })
                .catch((err) => {})
            } else {
                const result = HttpActualPost(path, payload)
                resolve(result)
            }
    })

    return promise

}


const HttpPostMultipart = (path, payload) => {

    let isAuthenticated = AuthService.isUserLoggedIn();


    var promise = new Promise((resolve, reject) => {

            if (isAuthenticated) {
               AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualPostMultipart(path, payload, accessToken)

                    resolve(result)
                }, (err)=>{
                    console.log("HttpActualPostMultipart error xxxx", err)

                })
                .catch((err) => {})
                
            } else {
                const result = HttpActualPostMultipart(path, payload)
                resolve(result)
            }
    })

    return promise

}

const HttpActualPost = (path, payload, accessToken = null) => {

    let token = accessToken;
    if(token)
        token = "Bearer " + token;

    let headerParameters = {
        headers: {
            Authorization : token, 
            "Ocp-Apim-Subscription-Key": SUBSCRIPTION_KEY
        }
    }
    console.log("headerParameters", headerParameters)
    let apiEndpoint = path;

    console.log("HttpPost final params xxxx", apiEndpoint , payload, headerParameters);

    let result = axios.post(apiEndpoint, payload, headerParameters)
    console.log("HttpActualPost", result);
    return result
}

const CustomHttpPostMultipart = (path, payload, token) => {

    var promise = new Promise((resolve, reject) => {
        const result = HttpActualPostMultipart(path, payload, token);

        resolve(result);
    })
     
    return promise
}

const HttpActualPostMultipart = (path, payload, accessToken = null) => {

    let token = accessToken;
    if(token)
        token = "Bearer " + token;

    let headerParameters = {
        headers: {
            Authorization : token, 
            "Ocp-Apim-Subscription-Key": SUBSCRIPTION_KEY,
            'Content-Type': 'multipart/form-data'
        }
    }
    console.log("headerParameters", headerParameters)
    let apiEndpoint = path;

    console.log("HttpActualPostMultipart apiEndpoint payload headerParameters xxxx", apiEndpoint, payload, headerParameters)

    let result = axios.post(apiEndpoint, payload, headerParameters)
    console.log("HttpActualPostMultipart", result);
    return result
}


const HttpGet = (path, parameters = '', subscriptionKey, loaderType) => {

    console.log("parametersxxx", parameters);
    console.log("subscriptionKeysxxx", subscriptionKey);

    let isAuthenticated = AuthService.isUserLoggedIn();

    var promise = new Promise((resolve, reject) => {
        try {   
            if (isAuthenticated) {
                 AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualGet(path, parameters, accessToken, subscriptionKey, loaderType)
                    
                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr uuu: ", err)
                })
            } else {
                const result = HttpActualGet(path, parameters, "", subscriptionKey, loaderType)
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_GET", error)
            reject(error)
        }
    })

    return promise

}

const HttpActualGet = (path, parameters = '', accessToken = null, subscriptionKey, loaderType) => {
    
    let token;

    if (accessToken) {
        token = "Bearer " + accessToken;
    }

    let headerParameters = {
        headers: {
            Authorization: token,
            "Ocp-Apim-Subscription-Key": subscriptionKey
        }
    }

    console.log("HttpActualGetheaderParameters", headerParameters);

    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(parameters);
    
    if (queryParams) {
        queryParams =  "?" + queryParams;
    } else {
        queryParams = '';
    }

    console.log("GetURL:", apiEndpoint + queryParams);
    let result = axios.get(apiEndpoint + queryParams, headerParameters);

    console.log("HttpActualGet result xxxx", result);
    
    return result
}

const HttpRawGet = (path, parameters = '', subscriptionKey, loaderType) => {

    console.log("HttpRawGet():", parameters);
    console.log("path():", path);
    console.log("subscriptionKey():", subscriptionKey);
    console.log("loaderType():", loaderType);


    let isAuthenticated = AuthService.isUserLoggedIn();


    var promise = new Promise((resolve, reject) => {
        try {   
            if (isAuthenticated) {
                console.log("HttpRawGet() isAuthenticated:", isAuthenticated);
               AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualRawGet(path, parameters, accessToken, subscriptionKey, loaderType)

                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr: ", err)

                })
            } else {
                const result = HttpActualRawGet(path, parameters, "", subscriptionKey, loaderType)
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_RAW_GET", error)
            reject(error)
        }
    })

    return promise

}

const HttpActualRawGet = (path, parameters = '', accessToken = null, subscriptionKey, loaderType) => {
    
    let token;

    if (accessToken) {
        token = "Bearer " + accessToken;
    }

    let headerParameters = {
        headers: {
            Authorization: token,
            "Ocp-Apim-Subscription-Key": subscriptionKey
        }
    }

    console.log("headersHere", headerParameters)

    let apiEndpoint = path + "?" + parameters;

    console.log("GetURL:", apiEndpoint);

    return axios.get(apiEndpoint, headerParameters)
}



const HttpPut = (path, payload) => {


    let isAuthenticated = AuthService.isUserLoggedIn();

    var promise = new Promise((resolve, reject) => {
        try {   

            if (isAuthenticated) {
               AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualPut(path, payload, accessToken)

                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr: ", err)

                })
                .catch((err) => {})

            } else {
                const result = HttpActualPut(path, payload)
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_PUT", error)
            reject(error)
        }
    })

    return promise

}

const HttpActualPut = (path, payload, accessToken = null) => {
    
    let token = accessToken;

    if(token)
        token = "Bearer " + token;

    let headerParameters = {
        headers: {
            Authorization : token,
            "Ocp-Apim-Subscription-Key": SUBSCRIPTION_KEY,
        }
    }

    let apiEndpoint = path;

    let result = axios.put(apiEndpoint , payload, headerParameters)
    console.log("HttpActualPut", result);
    return result;
    
}


const HttpPut1 = (path, parameters="", payload) => {

    let isAuthenticated = AuthService.isUserLoggedIn();

    var promise = new Promise((resolve, reject) => {
        try {   

            if (isAuthenticated) {

                console.log("HttpPut1 path parameters payload xxxx", path, parameters, payload)
               AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualPut1(path, parameters, payload, accessToken)

                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr: ", err)
                })
            } else {
                const result = HttpActualPut1(path, parameters = '', payload, )
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_PUT", error)
            reject(error)
        }
    })

    return promise

}

const HttpActualPut1 = (path, parameters = "", payload, accessToken = null) => {
    
    let token;

    if (accessToken) {
        token = "Bearer " + accessToken;
    }

    let headerParameters = {
        headers: {
            Authorization: token,
            "Ocp-Apim-Subscription-Key": SUBSCRIPTION_KEY
        }
    }

    console.log("HttpPutheaderParameters xxxx", headerParameters, path, parameters, payload, accessToken);

    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(parameters);
    
    if (queryParams) {
        queryParams =  "?" + queryParams;
    } else {
        queryParams = '';
    }

    console.log("GetURL:", apiEndpoint + queryParams);
    let result = axios.put(apiEndpoint + queryParams, payload, headerParameters);

    console.log("HttpPut result xxxx", result);
    return result;
}

const HttpActualDeleteBodyRequest = (path, parameters = '', payload, accessToken = null) => {
    
    let token = accessToken;

    if(token)
        token = "Bearer " + token;

    let headerParameters = {
        Authorization : token,
        "Ocp-Apim-Subscription-Key": SUBSCRIPTION_KEY,
    }

    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(parameters)
    if(queryParams)
        queryParams =  "?" + queryParams;
    else
        queryParams = '';

    let result = axios.delete(apiEndpoint + queryParams, {data: payload, headers: headerParameters})

    return result;
}

const HttpDeleteBodyRequest = (path, parameters, payload) => {

    console.log("HttpDeleteBodyRequest payload aa", payload);

    const MsalAuthenticate = window.MsalAuthenticate
    let isAuthenticated = AuthService.isUserLoggedIn();

    var promise = new Promise((resolve, reject) => {
        try {   

            if (isAuthenticated) {
               AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualDeleteBodyRequest(path, parameters, payload, accessToken)

                    resolve(result)
                }, (err)=>{
                    log("errrrrrr: ", err)
                    MsalAuthenticate.getTokenPopup().then(({accessToken})=>{
                        setAuthToken(accessToken)
                        const result = HttpActualDeleteBodyRequest(path, parameters, payload, accessToken)

                        resolve(result)
                    }, (err)=>{
                        log("errrrrrr xxx: ", err)
                        // logout
                        localStorage.clear()
                        window.location.reload()
                    })
                })
                .catch((err) => {})

            } else {
                const result = HttpActualDeleteBodyRequest(path, parameters, payload)
                resolve(result)
            }

        } catch (error) {
            log("HttpActualDeleteBodyRequest", error)
            reject(error)
        }
    })

    return promise

}

const HttpDelete = (path, parameters) => {


    const MsalAuthenticate = window.MsalAuthenticate
    let isAuthenticated = AuthService.isUserLoggedIn();

    var promise = new Promise((resolve, reject) => {
        try {   

            if (isAuthenticated) {
               AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualDelete(path, parameters, accessToken)

                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr: ", err)
                    MsalAuthenticate.getTokenPopup().then(({accessToken})=>{
                        setAuthToken(accessToken)
                        const result = HttpActualDelete(path, parameters, accessToken)

                        resolve(result)
                    }, (err)=>{
                        console.log("errrrrrr xxx: ", err)
                        // logout
                        localStorage.clear()
                        window.location.reload()
                    })
                })
                .catch((err) => {})

            } else {
                const result = HttpActualDelete(path, parameters)
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_PUT", error)
            reject(error)
        }
    })

    return promise

}


const HttpDelete1 = (path, parameters) => {


    const MsalAuthenticate = window.MsalAuthenticate
    let isAuthenticated = AuthService.isUserLoggedIn();

    var promise = new Promise((resolve, reject) => {
        try {   

            if (isAuthenticated) {
               AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualDelete1(path, parameters, accessToken)

                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr: ", err)
                    MsalAuthenticate.getTokenPopup().then(({accessToken})=>{
                        setAuthToken(accessToken)
                        const result = HttpActualDelete1(path, parameters, accessToken)

                        resolve(result)
                    }, (err)=>{
                        console.log("errrrrrr xxx: ", err)
                        // logout
                        localStorage.clear()
                        window.location.reload()
                    })
                })
                .catch((err) => {})

            } else {
                const result = HttpActualDelete1(path, parameters)
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_PUT", error)
            reject(error)
        }
    })

    return promise

}

const HttpActualDelete = (path, parameters = '', accessToken = null) => {
    
    let token = accessToken;

    if(token)
        token = "Bearer " + token;

    let headerParameters = {
        headers: {
            Authorization : token,
            "Ocp-Apim-Subscription-Key": SUBSCRIPTION_KEY,
        }
    }

    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(parameters)
    if(queryParams)
        queryParams =  "?" + queryParams;
    else
        queryParams = '';

    let result = axios.delete(apiEndpoint + queryParams, headerParameters)

    return result;
}

const HttpActualDelete1 = (path, parameters = '', accessToken = null) => {
    
    let token = accessToken;

    if(token)
        token = "Bearer " + token;

    let headerParameters = {
        headers: {
            Authorization : token,
            "Ocp-Apim-Subscription-Key": SUBSCRIPTION_KEY,
        }
    }

    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(parameters)
    if(queryParams)
        queryParams =  "?" + queryParams;
    else
        queryParams = '';

    let result = axios.delete(apiEndpoint + queryParams, headerParameters)

    return result;
}


const HttpDownloadFile = (path, parameters = '', subscriptionKey) => {

    console.log("parametersxxx", parameters);
    console.log("subscriptionKeysxxx", subscriptionKey);


    let isAuthenticated = AuthService.isUserLoggedIn();

    var promise = new Promise((resolve, reject) => {
        try {   

            console.log("isAuthenticated oo", isAuthenticated);
            if (isAuthenticated) {
               AuthService.getAuthToken().then(({accessToken})=>{
                    console.log("accessTokenxxxx", accessToken);
                    setAuthToken(accessToken)
                    const result = HttpActualDownloadFile(path, parameters, accessToken, subscriptionKey)
                    
                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr uuu: ", err)

                })
            } else {
                const result = HttpActualDownloadFile(path, parameters, "", subscriptionKey)
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_GET", error)
            reject(error)
        }
    })

    return promise

}

const HttpActualDownloadFile = (path, parameters = '', accessToken = null, subscriptionKey) => {
    let token;

    if (accessToken) {
        token = "Bearer " + accessToken;
    }

    let options = {
        headers: {
            Authorization: token,
            "Ocp-Apim-Subscription-Key": subscriptionKey
        },
        responseType: 'blob',
    }

    console.log("Http Download File xxx", options);

    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(parameters);
    
    if (queryParams) {
        queryParams =  "?" + queryParams;
    } else {
        queryParams = '';
    }

    console.log("GetURL:", apiEndpoint + queryParams);
    let result = axios.get(apiEndpoint + queryParams, options)
    return result
}

const HttpPatch = (path, payload) => {
    let isAuthenticated = AuthService.isUserLoggedIn();

    var promise = new Promise((resolve, reject) => {
        if (isAuthenticated) {
            AuthService.getAuthToken().then(({accessToken}) => {
                setAuthToken(accessToken);

                const result = HttpActualPatch(path, payload, accessToken);
                resolve(result);

            },  (error) => {
                console.log("getAuthToken1 error xxxx", error);
                  
            }).catch((error) => {
                console.log("getAuthToken2 error xxxx", error);
            })

        } else {
            const result = HttpActualPatch(path, payload);

            resolve(result);
        }
    })

    return promise
}

const HttpActualPatch = (path, payload, accessToken = null) => {
    let token = accessToken;

    if (token)
        token = "Bearer " + token;

    let headerParameters = {
        headers: {
            Authorization : token, 
            "Ocp-Apim-Subscription-Key": SUBSCRIPTION_KEY
        }
    }

    console.log("headerParameters", headerParameters);

    let apiEndpoint = path;

    console.log("HttpPatch final params xxxx", apiEndpoint , payload, headerParameters);

    let result = axios.patch(apiEndpoint, payload, headerParameters);

    console.log("HttpActualPatch result xxxx", result);

    return result
}

const HttpCustomPost = (path, parameters = '', payload, subscriptionKey, loaderType) => {

    console.log("parametersxxx HttpCustomPost", parameters);
    console.log("subscriptionKeysxxx", subscriptionKey);

    let isAuthenticated = AuthService.isUserLoggedIn();

    var promise = new Promise((resolve, reject) => {
        try {   
            if (isAuthenticated) {
                 AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualCustomPost(path, parameters, payload, accessToken, subscriptionKey, loaderType)
                    
                    resolve(result)
                }, (err)=>{
                    console.log("errrrrrr uuu: ", err)
                })
            } else {
                const result = HttpActualCustomPost(path, parameters, payload, subscriptionKey, loaderType)
                resolve(result)
            }

        } catch (error) {
            console.log("HTTP_GET", error)
            reject(error)
        }
    })

    return promise

}

const HttpActualCustomPost = (path, parameters = '', payload, accessToken = null, subscriptionKey, loaderType) => {
    
    let token;

    if (accessToken) {
        token = "Bearer " + accessToken;
    }

    let headerParameters = {
        headers: {
            Authorization: token,
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            "Content-Type": "text/plain" // Set content type to JSON
        }
    }

    console.log("HttpActualGetheaderParameters", headerParameters);

    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(parameters);
    
    if (queryParams) {
        queryParams =  "?" + queryParams;
    } else {
        queryParams = '';
    }

    console.log("GetURL:", apiEndpoint + queryParams);

    let result = axios.post(apiEndpoint + queryParams, payload, headerParameters);

    console.log("HttpActualGet result xxxx", result);
    
    return result;
}

const HttpPost1 = (path, parameters = '', payload, subscriptionKey, loaderType) => {

    log("parametersxxx HttpPost1", parameters);
    log("subscriptionKeysxxx", subscriptionKey);

    let isAuthenticated = AuthService.isUserLoggedIn();

    var promise = new Promise((resolve, reject) => {
        try {   
            if (isAuthenticated) {
                 AuthService.getAuthToken().then(({accessToken})=>{
                    setAuthToken(accessToken)
                    const result = HttpActualPost1(path, parameters, payload, accessToken, subscriptionKey, loaderType)
                    
                    resolve(result)
                }, (err)=>{
                    log("errrrrrr uuu: ", err)
                })
            } else {
                const result = HttpActualPost1(path, parameters, payload, subscriptionKey, loaderType)
                resolve(result)
            }

        } catch (error) {
            log("HTTP_GET", error)
            reject(error)
        }
    })

    return promise

}

const HttpActualPost1 = (path, parameters = '', payload, accessToken = null, subscriptionKey, loaderType) => {
    
    let token;

    if (accessToken) {
        token = "Bearer " + accessToken;
    }

    let headerParameters = {
        headers: {
            Authorization: token,
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            "Content-Type": "text/plain" // Set content type to JSON
        }
    }

    log("HttpActualGetheaderParameters", headerParameters);

    let apiEndpoint = path;
    let queryParams = QueryParamsFormat(parameters);
    
    if (queryParams) {
        queryParams =  "?" + queryParams;
    } else {
        queryParams = '';
    }

    log("GetURL:", apiEndpoint + queryParams);

    let result = axios.post(apiEndpoint + queryParams, payload, headerParameters);

    log("HttpActualGet result xxxx", result);
    
    return result;
}





export {HttpRawGet,HttpPost, HttpActualPost, HttpGet, HttpActualGet, HttpPut, HttpActualPut, HttpDelete, HttpActualDelete, HttpDeleteBodyRequest,
    HttpDownloadFile,HttpPostMultipart, HttpActualPostMultipart, HttpPut1, HttpActualPut1, HttpPatch, HttpCustomPost, CustomHttpPostMultipart, 
    HttpDelete1, HttpActualDelete1, HttpPost1, HttpActualPost1}
